import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RegisterRequest } from './models/RegisterRequest';
import { ILogin } from './state';

export const register = createAsyncThunk(
  'Auth/register',
  async (data: RegisterRequest) => {
    try {
      await API.register(data);
      return data.email;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo al registrar el usuario',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);

export const login = createAsyncThunk(
  'Auth/login',
  async ({ data, isGoogleAuth, googleCredentialResponse }: ILogin) => {
    try {
      if (isGoogleAuth) {
        const res = await API.googleAuth(googleCredentialResponse);
        return res.data;
      }

      const res = await API.login(data);
      return { ...res.data, email: data?.email };
    } catch (error) {
      const err = error as any;
      if (err?.code === 'ERR_BAD_REQUEST') {
        Swal.fire({
          icon: 'info',
          title: 'Acceso Denegado',
          text: 'Por favor, contacta con el administrador',
        });
        throw error;
      }
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error en login',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);

export const logout = createAsyncThunk('Auth/logout', async () => {
  try {
    // const res = await API.logout();
    const res = {};
    return res;
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Hubo un error en login',
      text: 'Por favor, intenta de nuevo',
    });
    throw error;
  }
});
